export type UserManagementClientsAction = 'add' | 'detail' | 'edit';

export interface UserManagementClientsRoute {
    action: UserManagementClientsAction | null;
    id: string | null;
}

const BASE_PATH = '/user_management/clients';

const VALID_ACTIONS: UserManagementClientsAction[] = ['add', 'detail', 'edit'];

export const buildUserManagementClientsBasePath = (): string => BASE_PATH;

export const buildUserManagementClientsActionPath = (
    action: UserManagementClientsAction,
    id?: string | null
): string => {
    if (action === 'add') {
        return `${BASE_PATH}/add`;
    }

    if (!id) {
        return BASE_PATH;
    }

    return `${BASE_PATH}/${action}/${encodeURIComponent(id)}`;
};

export const parseUserManagementClientsRoute = (
    pathname: string
): UserManagementClientsRoute => {
    const segments = pathname.split('/').filter(Boolean);

    if (segments[0] !== 'user_management' || segments[1] !== 'clients') {
        return { action: null, id: null };
    }

    const action = segments[2] as UserManagementClientsAction | undefined;
    if (!action || !VALID_ACTIONS.includes(action)) {
        return { action: null, id: null };
    }

    if (action === 'add') {
        return { action, id: null };
    }

    const rawId = segments[3];
    if (!rawId) {
        return { action: null, id: null };
    }

    return {
        action,
        id: decodeURIComponent(rawId),
    };
};